import React, { useState } from 'react';
import { Button, Tab, Tabs } from 'react-bootstrap';
import AutoGrowTextArea from '../common/AutoGrowTextArea';
import SlidingSideBar from '../SlidingSideBar/SlidingSideBar';

const NotesSidebar = ({ crmNotesMeta, onCrmNotesMetadataChange, updatingNotes, onUpdateNotes }) => {
  const [activeTab, setActiveTab] = useState('personalNotes');

  return (
    <SlidingSideBar
      visible={crmNotesMeta}
      onClose={() => onCrmNotesMetadataChange(null)}
      title="Notes"
      className="notes-sidebar"
    >
      <Tabs activeKey={activeTab} onSelect={k => setActiveTab(k)} className="custom-tabs" variant="pills">
        <Tab
          eventKey="personalNotes"
          title={<span style={{ color: activeTab === 'personalNotes' ? 'inherit' : 'gray' }}>Personal Notes</span>}
          className="mt-2"
        >
          <div className="overflow-auto">
            <AutoGrowTextArea
              triggerResize={activeTab === 'personalNotes'}
              value={crmNotesMeta?.personalNotes}
              onChange={e =>
                onCrmNotesMetadataChange({
                  ...crmNotesMeta,
                  personalNotes: e.target.value
                })
              }
              rows={3}
              as="textarea"
              disabled={updatingNotes}
              style={{ minHeight: 100, maxHeight: '75vh' }}
            />
          </div>
        </Tab>

        <Tab
          eventKey="consultantsFollowUpNotes"
          title={
            <span style={{ color: activeTab === 'consultantsFollowUpNotes' ? 'inherit' : 'gray' }}>
              Consultant Follow Up Notes
            </span>
          }
          className="mt-2"
        >
          <div className="overflow-auto">
            <AutoGrowTextArea
              triggerResize={activeTab === 'consultantsFollowUpNotes'}
              value={crmNotesMeta?.consultantsFollowUpNotes}
              onChange={e =>
                onCrmNotesMetadataChange({
                  ...crmNotesMeta,
                  consultantsFollowUpNotes: e.target.value
                })
              }
              rows={3}
              as="textarea"
              disabled={updatingNotes}
              style={{ minHeight: 100, maxHeight: '75vh' }}
            />
          </div>
        </Tab>
      </Tabs>

      <div className="fixed-bottom-button d-flex justify-content-end bg-white px-3 pt-3">
        <Button
          onClick={onUpdateNotes}
          variant="primary"
          className="p-2"
          disabled={updatingNotes}
          style={{ width: '120px' }}
        >
          {updatingNotes ? 'Updating...' : 'Update'}
        </Button>
      </div>
    </SlidingSideBar>
  );
};

export default NotesSidebar;
